import { ChangeEvent, FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Upload } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';

interface CsvUploadButtonProps {
  onFile: (file: File) => void | Promise<void>;
  isUploading: boolean;
  disabled?: boolean;
}

const CsvUploadButton: FC<CsvUploadButtonProps> = ({
  onFile,
  isUploading,
  disabled,
}) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.currentTarget;
    const file = input.files?.item(0);
    // Cleared so picking the same file again still fires a change.
    input.value = '';
    if (file) await onFile(file);
  };

  return (
    <>
      <input
        ref={inputRef}
        type='file'
        accept='.csv,text/csv'
        className='hidden'
        onChange={handleChange}
      />
      <Button
        variant='outline'
        size='sm'
        className='shrink-0'
        disabled={(disabled ?? false) || isUploading}
        onClick={() => {
          inputRef.current?.click();
        }}>
        {isUploading ? <Spinner /> : <Upload />}
        {t('scenarios.create.uploadCsv')}
      </Button>
    </>
  );
};

export default CsvUploadButton;
